/** Words of the assessment page that are ours (TP's words live in growth-score-content.ts and search-content.ts). */
export const ASSESSMENT_COPY = {
  backToChat: 'Back to chat',
  /** The hint on every action that would start work: nothing runs before the person has signed up (plan H3, TD-4.5). */
  planningAfterSignup: 'Planning starts after you sign up.',
  pageLabel: 'Growth Score assessment',
  loading: 'Building your assessment…',
  failedTitle: "We couldn't load your assessment",
  failedBody: 'Something went wrong on our side. Try again in a moment.',
  retry: 'Try again',
} as const
